class KlaviyoBackInStock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.submitButton = this.getSubmitEl();
    this.inputEl = this.getInputEl();
    this.messageEl = this.getMessageEl();
    
    this.emptyFieldErrorMsg = window.theme.strings.general.bis.bis_notify_invalid_email;
    this.successMessage = window.theme.strings.general.bis.bis_notify_success_message;
  }

  setupListeners () {
    this.handleSubmit = this.handleSubmit.bind(this)
    this.listeners.add(this.getSubmitEl(), 'click', this.handleSubmit)
  }

  async handleSubmit() {
  if (!this.inputEl.value.trim()) {
    this.showErrorMsg(this.emptyFieldErrorMsg);
    return;
  }

  const email = this.inputEl.value.trim();
  const rawId = this.dataset.bisVariantId;
  const variantId = `$shopify:::$default:::${rawId}`;

  try {
    const res = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=RSpJiv`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "revision": "2026-04-15"
          },
          body: JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: email
                    }
                  }
                },
                channels: ["EMAIL"]
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: variantId
                  }
                }
              }
            }
          })
        }
      );

      // Safe parse response data, successful submissions do not have a response
      let data = null;
      try {
        data = await res.json();
      } catch {}

      if (!res.ok) {
        // show Klaviyo error message
        const msg = data?.errors?.[0]?.detail || window.theme.strings.general.bis.bis_notify_unknown_error_message;
        throw new Error(msg);
      }

      // show Success message
      this.showSuccessMsg(this.successMessage);
      // Clear input field
      this.inputEl.value = ""

    } catch (err) {
      console.error(err);
      this.showErrorMsg(err.message);
    }
  }

  showErrorMsg(msg) {
    this.messageEl.classList.add('show-msg')
    this.messageEl.style.color = "red"
    this.messageEl.innerText = msg;
  }

  showSuccessMsg(msg) {
    this.messageEl.classList.add('show-msg')
    this.messageEl.style.color = "#15803D"
    this.messageEl.innerText = msg;
  }

  getMessageEl () {
    return window.BAO.Utils.getElement(this.els.message.selector, {
      context: this,
    })
  }

  getInputEl () {
    return window.BAO.Utils.getElement(this.els.input.selector, {
      context: this,
    })
  }

  getSubmitEl () {
    return window.BAO.Utils.getElement(`[data-klaviyo-back-in-stock-submit-id="${this.dataset.klaviyoBisSubmitId}"]`)
  }
}

if (!customElements.get('klaviyo-back-in-stock')) {
  customElements.define('klaviyo-back-in-stock', KlaviyoBackInStock)
}
